import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const AuthGuard = ({ children }) => {
    const isAuthenticated = () => Cookies.get('token') !== undefined;

    return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

export default AuthGuard;
